import { render, staticRenderFns } from "./ZoomBlock.vue?vue&type=template&id=49975894&scoped=true&"
import script from "./ZoomBlock.vue?vue&type=script&lang=js&"
export * from "./ZoomBlock.vue?vue&type=script&lang=js&"
import style0 from "./ZoomBlock.vue?vue&type=style&index=0&id=49975894&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49975894",
  null
  
)

export default component.exports